module.exports = "img/3.d6e21b.webp";